import React, { useEffect, useState } from 'react';
import IncrementButton from '../../../../../../atomic/buttons/incrementButton/IncrementButton';
import style from './PositionTacticsContainer.module.css';
import { colors } from '../../../../../../../colorVars';
import PositionModuleWrapper from '../moduleWrapper/PositionModuleWrapper';

const tacticList = ['Scaling In', 'Add To Winner'];

function PositionTacticsContainer(props) {
  const [currentSelection, setCurrentSelection] = useState('default');
  const [moduleList, setModuleList] = useState([]);

  const addTactic = () => {
    if (moduleList.includes(currentSelection) || currentSelection === 'default')
      return;
    setModuleList((prevState) => [...prevState, currentSelection]);
    setCurrentSelection('default');
  };

  const removeTactic = (index) => {
    const newArr = [...moduleList];
    newArr.splice(index, 1);
    setModuleList(newArr);
  };
  const camelToCapitalized = (string) => {
    const result = string.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  };
  const updateModuleList = () => {
    const filteredArr = Object.keys(props).filter(
      (item) => item !== 'top' && props[item][2] === true
    );
    const capitalizedArr = filteredArr.map((item) => camelToCapitalized(item));
    setModuleList(capitalizedArr);
  };
  useEffect(() => {
    updateModuleList();
  }, [props]);

  return (
    <div className={style.container}>
      <div className={style.addTactic}>
        <select
          style={{ width: '172px' }}
          className={style.input}
          value={currentSelection}
          onChange={({ target }) => setCurrentSelection(target.value)}
        >
          <option value="default">Select position tactic...</option>
          {tacticList.map((tactic) => {
            return (
              <option key={tactic} value={tactic}>
                {tactic}
              </option>
            );
          })}
        </select>
        <IncrementButton
          width={10}
          color="white"
          backgroundColor={colors.blue}
          paddingPercent={30}
          stroke={2}
          handleClick={addTactic}
        />
      </div>
      <div>
        {moduleList.map((module, index) => (
          <PositionModuleWrapper
            key={module}
            index={index}
            type={module}
            removeTactic={removeTactic}
            stateProps={props}
          />
        ))}
      </div>
    </div>
  );
}

export default PositionTacticsContainer;
